import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../models/api-resource.interface';
import { TenantCommunicationTemplate } from './communication-template.interface';

export const TENANT_COMMUNICATION_TEMPLATE_INCLUDES = ['employer', 'tenant'];

export class CommunicationTemplateService {
   async getCommunicationTemplates(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<TenantCommunicationTemplate>>>(`/tenant-communication-templates`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getCommunicationTemplate() {
      throw Error('Method not implemented');
   }

   async postCommunicationTemplate() {
      throw Error('Method not implemented');
   }

   async putCommunicationTemplate() {
      throw Error('Method not implemented');
   }

   async deleteCommunicationTemplate() {
      throw Error('Method not implemented');
   }
}
